export default [
    {
        value: 'N',
        label: 'without_capping',
    },
    {
        value: 'W',
        label: 'week',
    },
    {
        value: 'D',
        label: 'day',
    },
    {
        value: 'M',
        label: 'month',
    },
]